/* LUXONAS — Coming Soon product page touches (29 Sep 2026).
   1. Arrival line reads "— only N piece(s)" (3 or fewer) or "— N pieces".
   2. A short reassurance under Notify me, with a showroom-viewing link.
   Runs only where the Coming Soon availability panel is on the page. */
(function () {
  function scarcity() {
    var note = document.getElementById('lux-av-note');
    if (!note) return;
    var match = note.textContent.trim().match(/^(.*?)\s+[—–-]\s+(\d+)\s+units?$/i);
    if (!match) return;
    var qty = parseInt(match[2], 10);
    var pieces = qty === 1 ? ' piece' : ' pieces';
    note.textContent = match[1] + ' — ' + (qty <= 3 ? 'only ' + qty + pieces : qty + pieces);
  }

  function notifyNote() {
    if (!document.querySelector('.lux-av-panel--coming-soon')) return;
    var button = document.getElementById('BIS_trigger');
    if (!button || document.getElementById('lux-cs-notify-note')) return;
    var note = document.createElement('p');
    note.id = 'lux-cs-notify-note';
    note.className = 'lux-cs-notify-note';
    note.innerHTML = 'We’ll email you the day it lands.<br><a href="/pages/contact">Want to see it first? Book a showroom viewing on arrival →</a>';
    button.insertAdjacentElement('afterend', note);
  }

  function styles() {
    if (document.getElementById('lux-cs-notify-style')) return;
    var style = document.createElement('style');
    style.id = 'lux-cs-notify-style';
    style.textContent = '.lux-cs-notify-note{margin:12px 0 0;text-align:center;font-size:12px;line-height:1.7;color:#6c6158}' +
      '.lux-cs-notify-note a{color:#211b16;text-decoration:none;border-bottom:1px solid rgba(33,27,22,.35)}';
    document.head.appendChild(style);
  }

  function run() {
    if (!document.querySelector('.lux-av-panel--coming-soon')) return;
    styles();
    scarcity();
    notifyNote();
    var note = document.getElementById('lux-av-note');
    if (note && 'MutationObserver' in window) {
      new MutationObserver(function () { scarcity(); notifyNote(); }).observe(note, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();